import { HttpErrorResponse } from "@angular/common/http";
import { NaxosProblemDetails } from "./naxos-problem-details";

export class NaxosError {
  title: string;
  message: string;
  error: Error | HttpErrorResponse | NaxosProblemDetails;
}
